/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'ValidationError';
        return _this;
    }
    return ValidationError;
}(Error));
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(url, timeoutMs) {
        var _this = _super.call(this, "Request to ".concat(url, " timed out after ").concat(timeoutMs / 1000, " seconds")) || this;
        _this.name = 'TimeoutError';
        return _this;
    }
    return TimeoutError;
}(Error));

function getFullUrl(baseUrl, path) {
    return "".concat(baseUrl).concat(path);
}

function httpPost(url, input, timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = 5000; }
    return __awaiter(this, void 0, void 0, function () {
        var response, err_1, isTimeoutError, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchWithTimeout(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(input),
                        }, timeoutMs)];
                case 1:
                    response = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    isTimeoutError = err_1 instanceof TimeoutError || (err_1 === null || err_1 === void 0 ? void 0 : err_1.name) === 'TimeoutError';
                    if (isTimeoutError) {
                        throw err_1;
                    }
                    throw new Error("Request to ".concat(url, " failed: ").concat(err_1 instanceof Error ? err_1.message : String(err_1)));
                case 3:
                    if (!response.ok) {
                        throw new Error("Request to ".concat(url, " failed with status ").concat(response.status, ": ").concat(response.statusText));
                    }
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, response.json()];
                case 5: return [2 /*return*/, _a.sent()];
                case 6:
                    err_2 = _a.sent();
                    throw new Error("Invalid JSON response from ".concat(url, ": ").concat(err_2.message));
                case 7: return [2 /*return*/];
            }
        });
    });
}
function fetchWithTimeout(url, options, timeoutMs) {
    return Promise.race([
        fetch(url, options),
        new Promise(function (_, reject) {
            return setTimeout(function () { return reject(new TimeoutError(url, timeoutMs)); }, timeoutMs);
        }),
    ]);
}

function validateInput(context) {
    var deviceId = context.deviceId, playerId = context.playerId, market = context.market;
    var isValidDeviceId = typeof deviceId === 'string' && deviceId.length > 0;
    var isValidPlayerId = !playerId || (typeof playerId === 'string' && playerId.length > 0);
    var isValidMarket = playerId ? typeof market === 'string' && market.length > 0 : true;
    if (!isValidDeviceId) {
        throw new ValidationError('"deviceId" is required in experiment context');
    }
    if (!isValidPlayerId) {
        throw new ValidationError('"playerId" must be a non-empty string if provided');
    }
    if (!isValidMarket) {
        throw new ValidationError('If you provide "playerId" then "market" is required');
    }
}
function validateOutput(response) {
    if (!Array.isArray(response)) {
        throw new ValidationError('Exp. service response is not an array');
    }
    for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
        var item = response_1[_i];
        var isValid = item.group && item.id && item.status;
        if (!isValid) {
            throw new ValidationError('Exp. service response item is missing required properties');
        }
    }
}
function runEvaluateEndpoint(apiUrl, context, timeoutMs) {
    return __awaiter(this, void 0, void 0, function () {
        var path, fullUrl, response, convertedResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    path = '/evaluate';
                    fullUrl = getFullUrl(apiUrl, path);
                    validateInput(context);
                    return [4 /*yield*/, httpPost(fullUrl, context, timeoutMs)];
                case 1:
                    response = _a.sent();
                    convertedResponse = response;
                    validateOutput(convertedResponse);
                    return [2 /*return*/, convertedResponse];
            }
        });
    });
}

var DefaultApi = /** @class */ (function () {
    function DefaultApi(apiUrl) {
        validateApiUrl(apiUrl);
        this.apiUrl = apiUrl;
    }
    DefaultApi.prototype.getEvaluateResponse = function (context, timeoutMs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, runEvaluateEndpoint(this.apiUrl, context, timeoutMs)];
            });
        });
    };
    return DefaultApi;
}());
function validateApiUrl(apiUrl) {
    var hasEndingSlash = apiUrl.endsWith('/');
    if (hasEndingSlash) {
        throw new Error('API URL should not end with a slash');
    }
}

var ExperimentEngagementService = /** @class */ (function () {
    function ExperimentEngagementService(apiUrl) {
        this.name = 'ExperimentEngagementService';
        this.context = null;
        this.experiments = [];
        this.api = new DefaultApi(apiUrl);
    }
    ExperimentEngagementService.prototype.initialize = function (nextContext, timeoutMs) {
        if (timeoutMs === void 0) { timeoutMs = 5000; }
        return __awaiter(this, void 0, void 0, function () {
            var isSameContext, _a, e_1, isValidationError, isTimeoutError, errorText;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isSameContext = JSON.stringify(nextContext) === JSON.stringify(this.context);
                        if (isSameContext) {
                            // Do nothing, we already loaded for this context
                            return [2 /*return*/, false];
                        }
                        this.context = nextContext;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.api.getEvaluateResponse(nextContext, timeoutMs)];
                    case 2:
                        _a.experiments = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        isValidationError = e_1 instanceof ValidationError || (e_1 === null || e_1 === void 0 ? void 0 : e_1.name) === 'ValidationError';
                        isTimeoutError = e_1 instanceof TimeoutError || (e_1 === null || e_1 === void 0 ? void 0 : e_1.name) === 'TimeoutError';
                        if (isValidationError) {
                            /*
                            If the service is used incorrectly (or has a backend prototocl mismatch)
                            throw an error and force engineers to handle it
                            */
                            throw e_1;
                        }
                        errorText = isTimeoutError
                            ? '[ExperimentEngagementService] Timeout while fetching experiments:'
                            : '[ExperimentEngagementService] Error fetching experiments:';
                        // Any other error, like timeout, network errors etc, have a failover
                        console.error(errorText, e_1);
                        this.experiments = [];
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    };
    ExperimentEngagementService.prototype.getExperiments = function () {
        if (!this.context) {
            throw new Error('ExperimentEngagementService not initialized. Call initialize() first.');
        }
        return this.experiments;
    };
    return ExperimentEngagementService;
}());

var ExperimentType;
(function (ExperimentType) {
    ExperimentType["Device"] = "device";
    ExperimentType["Player"] = "player";
})(ExperimentType || (ExperimentType = {}));

export { ExperimentEngagementService, ExperimentType };
//# sourceMappingURL=index.esm.js.map
